import { render, staticRenderFns } from "./ElegirTipo.vue?vue&type=template&id=4a9a6ed4&scoped=true"
import script from "./ElegirTipo.vue?vue&type=script&lang=js"
export * from "./ElegirTipo.vue?vue&type=script&lang=js"
import style0 from "./ElegirTipo.vue?vue&type=style&index=0&id=4a9a6ed4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a6ed4",
  null
  
)

export default component.exports